const today = new Date();

export default {
    subline: 'Eine Initiative von Pohl-Boskamp',
    copyright: `©Pohl-Boskamp ${today.getFullYear()}`,
};
